import { Vue, Component, Prop } from 'vue-property-decorator';
import ResponseHandlerModule from '@/store/modules/responseHandler';

@Component
export default class ImageInputMixin extends Vue {
    @Prop({ required: false }) readonly data?: any;
    
    get imageStyle() {
        let imageStyle = '';
        if (this.data.value) {
            imageStyle = `background: url(${this.data.value}) center center / cover no-repeat;`;
        }
        
        return imageStyle;
    }
    
    get imagePreviewStyle() {
        let imagePreviewStyle = '';
        if (this.data.preview) {
            imagePreviewStyle = `background: url(${this.data.preview}) center center / cover no-repeat;`;
        }
        
        return imagePreviewStyle;
    }
    
    loadImage($event: Event) {
        const target = $event.target as HTMLInputElement;
        
        if (!target.files) {
            return;
        }
        
        if (target.files[0].name.match(/.(jpg|jpeg|png)$/i)) {
            this.$emit('load-image', target?.files ? target?.files[0] : null);
        } else {
            ResponseHandlerModule.showNotify({ message: 'Ошибка! Неверный формат файла', type: 'fail' });
        }
    }
}
